import { Fragment, useContext, useState } from "react";
import "./Header.scss";
import { menuContext } from "../../context/menucontext";
import MenuIcon from "../../components/menuicon/MenuIcon";
import ArrowBtn from "../../components/arrowbtn/ArrowBtn";

import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png";

const Header = ({ scrolltheme }) => {
  const [num, setNum] = useState(0);

  const navigate = useNavigate();

  const bookdemo = () => {
    navigate("/contactus");
  };

  const theme = () => {
    if (scrolltheme) {
      return [1, 2, 3, 4].includes(num) ? "light" : "dark";
    } else {
      return "light";
    }
  };

  return (
    <Fragment>
      <header className={theme()}>
        <section className="header">
          <div className="content_wrap">
            <div className="left">
              <div className="logo_wrap" style={{ width: "120px" }}>
                <a href="/">
                  <img src={Logo} alt="Brand Logo" className={theme()} />
                </a>
              </div>
              <div className="nav_wrap">
                <NavLink to="/" className={`linkbtns ${theme()}`}>
                  Home
                </NavLink>
                <NavLink to="/about" className={`linkbtns ${theme()}`}>
                  About
                </NavLink>
                {/* <NavLink to="/solutions" className={`linkbtns ${theme()}`}>Solutions</NavLink> */}
                <NavLink to="/vendors" className={`linkbtns ${theme()}`}>
                  Vendors
                </NavLink>
                {/* <NavLink to="/services" className={`linkbtns ${theme()}`}>Services</NavLink> */}
                <NavLink to="/events" className={`linkbtns ${theme()}`}>
                  Events
                </NavLink>
                <NavLink to="/partnerwithus" className={`linkbtns ${theme()}`}>
                  Partner with us
                </NavLink>
                <NavLink to="/blog" className={`linkbtns ${theme()}`}>
                  Blog
                </NavLink>
                <NavLink to="/contactus" className={`linkbtns ${theme()}`}>
                  Contact
                </NavLink>
              </div>
            </div>
            <div className="right">
              <ArrowBtn
                text="Get in touch"
                handleClick={bookdemo}
                theme="secondary_ternery"
              />
              <MenuIcon theme={theme()} />
            </div>
          </div>
        </section>
   
      </header>
    </Fragment>
  );
};

export default Header;
